import React, {useEffect, useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    formatDate,
    getArrIndexValue,
    getCurrUrlParamValue,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    parseInteger,
    trim
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getAllocatedModuleName, getSubdomainSessionData, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {
    EVENT_INPUT_MAX_LEN,
    EventFormParticipantTypes as PARTICIPANT_TYPES,
    INPUT_FILE_MAX_SIZE,
    ModuleFieldsData,
    ModuleRouteUrls,
    Modules,
    ReqUrls,
} from "../../../config/AppConfig";
import {Avatar, Checkbox, Flexbox, GridBox, Label, MsgBox, PdfViewer, RadioToggle, SearchableCheckboxList} from "../../../../common/fusion-ui";
import {Constants, CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const CS_AddEdit_FormPage = React.memo(({
                                            updateOnly,
                                        }) => {
    const TAG = "CS_AddEdit_FormPage";

    const moduleName = Modules.CaseStudy;
    const mf = ModuleFieldsData[moduleName];
    const NAME_KEY = 'name';

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const FOCUS_DELAY = 2000;

    const Fields = {
        updateRecordId: 'updateRecordId',

        canShowAddForm: 'canShowAddForm',
        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        participantsLoading: 'participantsLoading',
        resetParticipantsList: 'resetParticipantsList',
        participantsLoaded: 'participantsLoaded',
        participantsLoadingMsg: 'participantsLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        currParticipantGroupId: 'currParticipantGroupId',
        isPdfFileLoading: 'isPdfFileLoading',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(CS_AddEdit_FormPage_Data);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        // setFormData({});
        const recordId = getCurrUrlParamValue('id');
        // log('useEffect.updateOnly:', isUpdateMode(), 'updateRecordId:', recordId);

        if (!checkNullStr(getFormField(mf.notificationTo))) {
            updateFormField(mf.notificationTo, true);
            if (!isUpdateMode()) {
                updateFormField(mf.participantDisplayType, PARTICIPANT_TYPES.membersOnly);
            }
        }

        if (isUpdateMode()) {
            fetchEditModeData(recordId);
        } else {
            fetchParticipantList([], true);
        }
    }, [updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            addPageTitle={getTabTitle()}
            editPageTitle={getTabTitle()}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}>
            <div>
                {/*title, author, date, link*/}
                <div>
                    {/*title*/}
                    <ThemedInput
                        wrapperClassName={''}
                        className={''}
                        label={mf.title.titleAlt}
                        placeholder={mf.title.titleAlt}
                        id={mf.title.column}
                        type={'text'}
                        value={getFormField(mf.title)}
                        msg={getFormFieldMsg(mf.title)}
                        showLimitLabel={true}
                        maxLength={EVENT_INPUT_MAX_LEN}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateFormField(mf.title, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.title, '');
                        }}
                    />

                    {/*date*/}
                    <ThemedInput
                        wrapperClassName={''}
                        className={''}
                        label={mf.date.titleAlt}
                        placeholder={mf.date.titleAlt}
                        id={mf.date.column}
                        type={'date'}
                        value={getFormField(mf.date)}
                        msg={getFormFieldMsg(mf.date)}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateFormField(mf.date, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.date, '');
                        }}
                    />

                    {/*author*/}
                    <ThemedInput
                        wrapperClassName={''}
                        className={''}
                        label={mf.author.title}
                        placeholder={mf.author.title}
                        id={mf.author.column}
                        type={'text'}
                        value={getFormField(mf.author)}
                        msg={getFormFieldMsg(mf.author)}
                        showLimitLabel={true}
                        maxLength={EVENT_INPUT_MAX_LEN}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateFormField(mf.author, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.author, '');
                        }}
                    />

                    {/*desc*/}
                    <ThemedInput
                        wrapperClassName={''}
                        className={''}
                        label={mf.desc.title}
                        placeholder={mf.desc.title}
                        id={mf.desc.column}
                        type={'text'}
                        value={getFormField(mf.desc)}
                        msg={getFormFieldMsg(mf.desc)}
                        showLimitLabel={true}
                        maxLength={EVENT_INPUT_MAX_LEN}
                        asTextArea={true}
                        style={{
                            minHeight: '60px',
                            height: '140px',
                            maxHeight: '200px'
                        }}
                        required={true}
                        onChange={(e) => {
                            const value = e.target.value;
                            updateFormField(mf.desc, value);
                            if (checkNullStr(value)) updateFormFieldMsg(mf.desc, '');
                        }}
                    />
                </div>

                {/*file, desc*/}
                <div className={'mt-3x'}>
                    <GridBox className={'px-2'} md={[4, 8]} sm={[12, 12]}>
                        {/*file*/}
                        <div className={''}>
                            <Avatar
                                wrapperClassName={'w-100'}
                                className={''}
                                labelClassName={'w-100x pb-2 text-startxx'}
                                justifyAt={'center'}
                                alignAt={'start'}
                                wrap={'wrap'}
                                direction={'column'}
                                label={mf.file.title}
                                labelColor={theme.text40}
                                // Updated by Vandit Tewari (5/11/24) - Done this bcz earlier it was accepting only pdf, png, jpg, jpeg format added few more formats by adding it on accept and  editTooltip variable
                                accept={'.docx, .pptx, .pdf, .jpg, .jpeg, .png'}
                                editTooltip={`Edit (.docx, .pptx, .pdf, .jpg, .jpeg, .png)`}
                                showEdit={true}
                                showDelete={true}
                                circular={false}
                                showFullPreviewDialog={true}
                                defAvatarImg={Constants.docVector}
                                editSize={'21px'}
                                width={'100px'}
                                height={'140px'}
                                maxSize={INPUT_FILE_MAX_SIZE}
                                onChange={(e, file, path, name, ext) => {
                                    log('Avatar.file.onChange.name:', name, 'ext:', ext);
                                    updateFormField(mf.file, file);
                                    updateFormField(mf.docFileExt, ext);
                                }}
                                onInvalidFormat={(e, name) => {
                                    //update by Vandit Tewari (5/11/24) - added more formats in toast to give message
                                    toast(`Invalid file format. File must be .docx, .pptx, .pdf, .jpg, .jpeg, .png`, CssVariant.danger);
                                }}
                                onSizeExceeded={() => {
                                    toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                }}
                                onFileLoading={(loading) => {
                                    updateField(Fields.isPdfFileLoading, isBoolTrue(loading));
                                }}>{getFormField(mf.file)}</Avatar>
                        </div>

                        {/*pdf-viewer*/}
                        {(checkNullStr(getFormField(mf.file)) &&
                                (getFormField(mf.docFileExt) + '').toLowerCase().trim().endsWith('.pdf')
                                && !isFieldTrue(Fields.isPdfFileLoading)) &&
                            <div className={'ps-3x pb-4'}>
                                <PdfViewer
                                    label={`${mf.file.title} Preview`}
                                    pdfTitle={mf.file.title}
                                    src={getFormField(mf.file)}
                                    labelColor={theme.text}
                                    height={'240px'}
                                />
                            </div>}
                    </GridBox>
                </div>

                {/*url*/}
                <ThemedInput
                    wrapperClassName={'mt-3'}
                    className={''}
                    label={mf.url.titleAlt3}
                    placeholder={mf.url.titleAlt3}
                    id={mf.url.column}
                    type={'text'}
                    value={getFormField(mf.url)}
                    msg={getFormFieldMsg(mf.url)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(mf.url, value);
                        if (checkNullStr(value)) updateFormFieldMsg(mf.url, '');
                    }}
                />

                {/* participants cb-list   */}
                <div className={'mt-3x'}>
                    {createLabelField(mf.notificationTo.title, true)}

                    {/*participantDisplayType*/}
                    <RadioToggle
                        className={`bg-infox px-3x`}
                        radioClassName={'w-auto'}
                        labelClassName={'fw-semi-bold text-input-label'}
                        labelColor={theme.text40}
                        cbPy={0}
                        required={true}
                        checked={getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.membersOnly}
                        config={{
                            // label: "Participant Type",
                            active: PARTICIPANT_TYPES.membersOnly,
                            inactive: PARTICIPANT_TYPES.groupsOnly,
                        }}
                        onChange={(e, value) => {
                            // log('participantDisplayType.RadioToggle.onChange.value:', value);
                            updateFormField(mf.participantDisplayType, value);
                        }}
                    />

                    {/*notificationTo*/}
                    <Checkbox
                        wrapperClassName={''}
                        className={''}
                        checkmarkMarginTop={''}
                        labelClassName={''}
                        defaultChecked={isFormFieldTrue(mf.notificationTo)}
                        checked={isFormFieldTrue(mf.notificationTo)}
                        onChange={(e, value) => {
                            updateFormField(mf.notificationTo, value);
                        }}>{"Send Notification Email"}</Checkbox>

                    {/*participants & groups*/}
                    <div className={'px-2'}>
                        {/*groups grid*/}
                        {(getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.groupsOnly) && <div>
                            {(checkNullArr(getParticipantGroupsList()))
                                ? <GridBox className={'px-3'} sm={12} md={4} gap={0}>
                                    {getParticipantGroupsList().map((cbItem, index) => {
                                        return (checkNullJson(cbItem)) && <Checkbox
                                            key={cbItem[NAME_KEY] + index}
                                            wrapperClassName={''}
                                            className={''}
                                            labelClassName={'fw-semi-bold'}
                                            defaultChecked={getField(Fields.currParticipantGroupId) == cbItem.id}
                                            checked={getField(Fields.currParticipantGroupId) == cbItem.id}
                                            onChange={(e, value) => {
                                                updateField(Fields.currParticipantGroupId, value ? cbItem.id : null);
                                                // log('participantGroupNames.map.cb.onChange.value:', value, 'id:', cbItem.id);

                                                let names = getParticipantGroupsList();
                                                names = names.map((nameItem) => {
                                                    return {
                                                        ...nameItem,
                                                        selected: nameItem[NAME_KEY] == cbItem[NAME_KEY] ? value : isBoolTrue(nameItem.selected),
                                                    }
                                                });
                                                updateFormField(mf.participantGroupNames, names);
                                                // log('participantGroupNames.map.cb.onChange.value:', value, '\nnames:', names);
                                                // log('curr-cbItem.name:', cbItem.name, 'curr-name-found', names.some(item => (isJsonValueTrue(item,'selected'))));
                                            }}
                                        >{cbItem.name}</Checkbox>
                                    })}
                                </GridBox>
                                : createLabelField('No groups found!', false, theme.text, '')}
                        </div>}

                        {/*participant-list*/}
                        <div>
                            <SearchableCheckboxList
                                roundedVariant={4}
                                listHeight={'50vh'}
                                searchPlaceholder={'Search members...'}
                                borderColor={theme.text30}
                                showSelect={false}
                                pad={2}
                                checkListColumnCount={3}
                                showDisplaySelectedOnly={true}
                                isCheckItemJson={true}
                                checkItemJsonIdKey={'id'}
                                checkItemJsonTextKey={'name'}
                                checkDataList={getParticipantList()}
                                onValueChange={(e, value, selectedList) => {
                                    // log('participantNames-searchList.onValueChange.selectedList:', selectedList, 'len:', selectedList.length);
                                    updateFormField(mf.participantNamesSelectedOnly, selectedList);
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/*footer*/}
                <div className={'mt-3'}>
                    {/*msg-box*/}
                    {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                        {getField(Fields.panelMsg)}
                    </MsgBox>}

                    {/*controls*/}
                    <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                        <ThemedButton
                            className={'rounded-2 w-auto px-4 py-1'}
                            text={isFieldTrue(Fields.submitBtn_AsLoading)
                                ? isUpdateMode() ? 'Updating...' : 'Saving...'
                                : isUpdateMode() ? 'Update' : 'Save'}
                            variant={theme.primaryBlue}
                            hoverBgColor={theme.primaryBlueDark}
                            loadingWidth={'auto'}
                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                            onClick={handleSubmit}
                        />
                    </Flexbox>
                </div>
            </div>
        </FormPageRoot>
    </>)

    //======================UI Functions start=====================
    function createLabelField(label, required, color = theme.text40, className) {
        return <Label className={`text-input-label m-0 p-0 px-2 pb-1 ${className}`}
                      color={color} textAt={'start'} required={required}>
            {label}
        </Label>
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    browserUrl: window.location.href,
                    formData: formData,
                    subdomainData: getSubdomainSessionData(),
                };
                sendRequest({
                    reqUrl: ReqUrls.cs__addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            redirectPage();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchParticipantList(selectedIntIds = [], isAddMode) {
        const fun = 'fetchParticipantList:';
        try {
            if (!isFieldTrue(Fields.participantsLoaded)) {
                updateField(Fields.participantsLoaded, true);
                updateField(Fields.participantsLoading, true);
                if (isBoolTrue(isAddMode)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.dataLoadingMsg, "");
                }

                const REQUEST_OPTIONS = {};
                sendRequest({
                    reqUrl: ReqUrls.eventForm__fetch_participantsList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        let members = getJsonValueFromNestedKeys(fetchedData, ['data', 'members'], []);
                        let groups = getJsonValueFromNestedKeys(fetchedData, ['data', 'groups'], []);
                        // log(fun, 'fetchedData.members:', members, 'groups:', groups);

                        //select selectedIntIds by-default
                        // if (isUpdateMode()) log(fun, 'selectedIntIds:', selectedIntIds);
                        if (checkNullArr(members) && checkNullArr(selectedIntIds)) {
                            members = members.map((item) => {
                                return {
                                    ...item,
                                    selected: checkNullArr(selectedIntIds) && selectedIntIds.includes(parseInteger(getJsonValue(item, 'id'), -1))
                                };
                            });
                            updateFormField(mf.participantNamesSelectedOnly, members.filter(filterItem => isJsonValueTrue(filterItem, 'selected')));
                        }

                        updateField(Fields.participantsLoading, false);
                        updateField(Fields.participantsLoaded, true);

                        updateFormField(mf.participantNames, members);
                        updateFormField(mf.participantGroupNames, groups);
                        if (isBoolTrue(isAddMode)) {
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.isDataFound, true);
                        }
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        if (isBoolTrue(isAddMode)) {
                            updateField(Fields.isDataLoading, false);
                            updateField(Fields.isDataFound, true);
                        }
                        updateField(Fields.participantsLoading, false);
                        updateField(Fields.participantsLoaded, true);
                        updateField(Fields.participantsLoadingMsg, "Couldn't load participants!");
                    }),
                });
            }
        } catch (error) {
            logErr(fun, error);
            if (isBoolTrue(isAddMode)) {
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, true);
            }

            updateField(Fields.participantsLoading, false);
            updateField(Fields.participantsLoaded, true);
            updateField(Fields.participantsLoadingMsg, "Couldn't load participants!");
        }
    }

    async function fetchEditModeData(recordId) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));

            if (!isFieldTrue(Fields.isUpdateFormDataFetched)) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.cs__addEditPage_fetch_editFormData,//add url here
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const success = checkNullJson(fetchedFormData);

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast('Successfully fetched your data.', CssVariant.success);

                                //modify the date-formats of start & end dates otherwise date-inputs won't show the dates
                                const date = formatDate(getJsonValue(fetchedFormData, mf.date.column), Constants.YYYY_MM_DD_DASH);
                                fetchedFormData[mf.date.column] = date;
                                // log(fun, 'fetchedData.date:', date, '\nfetchedFormData-after:', fetchedFormData);

                                setFormData(fetchedFormData);

                                //Update participantDisplayType, bcuz it doesn't come from database
                                updateFormField(mf.participantDisplayType, PARTICIPANT_TYPES.membersOnly);

                                //extract participants ids to be by-default selected
                                const prtscptIdsStr = getJsonValue(fetchedFormData, mf.notificationTo.column) + '';
                                // log(fun, 'fetchedData.prtscptIdsStr:', prtscptIdsStr);
                                // if (checkNullStr(prtscptIdsStr)) {
                                const selectedIds = checkNullStr(prtscptIdsStr) ? prtscptIdsStr.split(',').map(item => parseInteger(trim(item), -1)) : [];
                                // log(fun, 'fetchedData.prtscptIdsStr.selectedIds:', selectedIds);
                                fetchParticipantList(selectedIds, false);
                                // }
                            } else {
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                window.location.href = ModuleRouteUrls[moduleName];
            }, 2500);
        }, 500);
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            mf.title,
            mf.date,
            mf.author,
            mf.desc,
            mf.url,
            mf.participantNamesSelectedOnly,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (field.column === mf.participantNamesSelectedOnly.column) {
                // const names = (getJsonValue(formData, field.column));
                // log(fun, "requiredFields.field.participantNames.names:", names);
                if (checkNullArr(getJsonValue(formData, field.column))) {
                    verified = true;
                } else {
                    colField = field;
                    verified = false;
                    break;
                }
            } else if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        // log('getParticipantList',getParticipantList());
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function getParticipantList(filtered = true) {
        if (checkNullArr(getFormField(mf.participantNames))) {
            if (getFormField(mf.participantDisplayType) == PARTICIPANT_TYPES.groupsOnly && filtered) {
                const currGroupId = getField(Fields.currParticipantGroupId);
                if (checkNullStr(currGroupId) && checkNullArr(getParticipantGroupsList())) {
                    return getJsonValue(getArrIndexValue(getParticipantGroupsList().filter(item => item.id == currGroupId), 0, {}), 'members', []);
                } else {
                    return [];
                }
            } else {
                return getFormField(mf.participantNames);
            }
        } else {
            return []
        }
    }

    function getParticipantGroupsList() {
        if (checkNullArr(getFormField(mf.participantGroupNames))) {
            return getFormField(mf.participantGroupNames);
        } else {
            return []
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function getTabTitle() {
        return isUpdateMode() ? `Edit ${getAllocatedModuleName(moduleName)}` : `Create ${getAllocatedModuleName(moduleName)}`;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default CS_AddEdit_FormPage;
